import React from 'react';
import { styled } from "../../../stitches.config"
import Link from "../../../components/Link";

import { ReactComponent as Img } from "./assets/info-img.svg?react"
import { ReactComponent as Button } from "./assets/info-btn.svg?react"

import dots from "./assets/dots.svg"


interface AtavistTestingInfoProps {
    link: string;
    title: string;
    src: string;
    text: string;
}

const AtavistTestingInfo: React.FC<AtavistTestingInfoProps> = ({
    link, title, src, text
}) => {

    const cleanLink = link.replace(/&nbsp;/g, ' ').replace(/<br\s*[\/]?>/gi, ' ').trim();

    return (
        <StyledAtavistTestingInfo>
            <Title><div></div>{title}</Title>
            <Info>
                <img src={src} />
                <div>
                    <p>{text}</p>
                    <Link to={cleanLink}>
                        <Button className="btn-svg" />
                    </Link>
                </div>
                <Img className="img-svg" />
            </Info>
        </StyledAtavistTestingInfo>
    );
};


const StyledAtavistTestingInfo = styled('div', {
    background: "#FEDDE8",
    color: "#131212",
    padding: "55px 10px 48px 10px",
    marginTop: "46px",
    "@bp4": {
        marginTop: "60px",
    },
    "@media(min-width: 1080px)": {
        paddingLeft: "calc(50% - 528px)",
    },
    "@media(min-width: 1850px)": {
        paddingLeft: "calc(50% - 748px)",
    },
    //svg
    ".img-svg": {
        width: "380px",
        flexShrink: 0,
        display: "none",
        "@media(min-width: 1850px)": {
            display: "block",
        }
    },
    ".btn-svg": {
        width: "calc(100% - 76px)",
        cursor: "pointer",
        margin: "20px 38px 0 38px",
        "@bp4": {
            margin: "20px 0 0 0",
            height: "64px",
            width: "400px",
        },
        "@media(min-width: 1850px)": {
            width: "500px",
        },
        "&:hover": {
            ".sti0": {
                transition: "0.3s",
                fill: "#2dcdcc",
            }
        }
    }
})

const Title = styled('div', {
    fontSize: "34px",
    lineHeight: "32px",
    fontWeight: "700",
    fontFamily: "$grotesk",
    display: "flex",
    justifyContent: "center",
    "@bp4": {
        justifyContent: "flex-start",
    },
    "div": {
        backgroundImage: `url("${dots}")`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        height: "28px",
        width: "12px",
        marginRight: "14px",
        marginTop: "2px",
    }
})

const Info = styled('div', {
    marginTop: "40px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "@bp4": {
        justifyContent: "flex-start",
        alignItems: "flex-start",
        display: "flex",
        flexDirection: "row",
    },
    "p": {
        margin: 0,
        maxWidth: "500px",
        fontSize: "20px",
        lineHeight: "32px",
        fontFamily: "$grotesk",
        padding: "0 46px",
        "@bp4": {
            padding: "0",
        },
        "@media(min-width: 1850px)": {
            marginRight: "60px",
            padding: "0",
        }
    },
    "img": {
        width: "100%",
        backgroundColor: "white",
        marginBottom: "24px",
        maxHeight: "448px",
        "@media(min-width: 528px)": {
            width: "528px",
            height: "448px",
        },
        "@bp4": {
            marginRight: "28px",
            marginBottom: "0px",
        }
    }
})


export default AtavistTestingInfo